// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resource-image[data-v-163365e9]{border-radius:19.875px}a[data-v-163365e9]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
